import React from 'react';
import styles from './components.module.css';

export interface FormProgressBarProps {
  currentPage: number;
  totalPages: number;
  showText?: boolean;
}

export const FormProgressBar: React.FC<FormProgressBarProps> = ({
  currentPage,
  totalPages,
  showText = true,
}) => {
  const progress = totalPages > 0 ? ((currentPage + 1) / totalPages) * 100 : 0;

  return (
    <div className={styles.progressContainer}>
      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{ width: `${progress}%` }}
        />
      </div>
      {showText && (
        <div className={styles.progressText}>
          Página {currentPage + 1} de {totalPages}
        </div>
      )}
    </div>
  );
};

export default FormProgressBar;
